/**
 * Convierte una fecha "YYYY-MM-DD" (el formato que entrega la API) a un Date
 * local a medianoche.
 *
 * Evita los dos parseos problematicos que habia en el codigo:
 * - `new Date('2026-09-15')` se interpreta como UTC y en Lima (UTC-5) retrocede
 *   al dia 14.
 * - `new Date(value + 'T09:00:00')` funciona, pero mete una hora arbitraria que
 *   ensucia cualquier comparacion por dia.
 *
 * Devuelve `null` si el valor esta vacio o mal formado: el llamador decide el
 * fallback.
 */
const parseYmd = (value?: string | number | Date | null): Date | null => {
  if (!value) return null;

  if (value instanceof Date) {
    return isNaN(value.getTime()) ? null : value;
  }

  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value));
  if (!match) return null;

  const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  return isNaN(date.getTime()) ? null : date;
};

export default parseYmd;
